import { Entity, registerSystem, System } from "aframe";
import { Box3, BufferGeometry, Matrix4, Object3D, Scene, Vector3 } from "three";



const expandBox = (el : Entity, obj : Object3D & { el ? : Entity, geometry ? : BufferGeometry }, box : Box3, temp : Box3, matrix : Matrix4) =>
{
	if(obj.el && (obj.el !== el)) return;

	if(obj.geometry)
	{
		obj.geometry.boundingBox || obj.geometry.computeBoundingBox();
		temp.copy(obj.geometry.boundingBox!);
		obj.updateWorldMatrix(true, false);
		temp.applyMatrix4(obj.matrixWorld);
		temp.applyMatrix4(matrix);
		box.union(temp);
	}

	for(let child of  obj.children)
		expandBox(el, child, box, temp, matrix);
}


registerSystem("debug", {

	tick(this : System)
	{
		if(!this.el.classList.contains("debug")) return; //Disabled

		const box = new Box3(), tempBox = new Box3();
		const pivot = new Vector3(), parent = new Vector3();
		const matrix = new Matrix4();
		const camera = this.el.camera;
		matrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);	

		const W = this.el.clientWidth, H = this.el.clientHeight;

		const toScreenSpace = (v : Vector3) => v.set(W * (0.5 + 0.5 * v.x), H * (0.5 - 0.5 * v.y), Math.floor(10000 * v.z) );

		for(let el of Array.from(this.el.querySelectorAll<Entity>("a-entity")))
		{
			el.dataset.debugComponents = Object.keys(el.components).join("\n");

			el.classList.toggle("debug-hidden", !el.object3D.visible);
			let hiddenParent = el.object3D;
			while(hiddenParent = hiddenParent.parent!)
				if(!hiddenParent.visible)
					break;
			el.classList.toggle("debug-hidden-parent", Boolean(hiddenParent));
			

			pivot.fromArray(el.object3D.matrixWorld.elements, 12);
			el.object3D.updateWorldMatrix(true, false);
			pivot.applyMatrix4(matrix);

			if( el.classList.toggle("debug-pivot-offscreen", pivot.z >= 1) )
				pivot.set(0,0,1);
			toScreenSpace(pivot);

			const p = el.parentElement as Entity;
			if(p && p.object3D && (p.tagName === 'A-ENTITY'))
			{
				p.object3D.updateWorldMatrix(true, false);
				parent.fromArray(p.object3D.matrixWorld.elements, 12);
				parent.applyMatrix4(matrix);
				if(parent.z >= 1)
					parent.set(0,0,1);
				toScreenSpace(parent);
			}
			else
				parent.set(0,0,0);

			el.style.left = String(pivot.x - parent.x) + "px";
			el.style.top = String(pivot.y - parent.y) + "px";
			el.style.zIndex = String(pivot.z - parent.z);


			box.makeEmpty();
			for(let key in el.object3DMap)
				expandBox(el, el.object3DMap[key], box, tempBox, matrix);


			if( el.classList.toggle("debug-box", !box.isEmpty() ))
			{
				if(box.max.z >= 1.0)
					el.classList.add("debug-box-offscreen");

				toScreenSpace(box.min);
				toScreenSpace(box.max);

				el.style.setProperty("--box-left", String(box.min.x - pivot.x) + "px");
				el.style.setProperty("--box-width", String(box.max.x - box.min.x) + "px");
				el.style.setProperty("--box-top", String(box.max.y - pivot.y) + "px");
				el.style.setProperty("--box-height", String(box.min.y - box.max.y) + "px");
				el.style.setProperty("--box-depth", String(box.max.z - pivot.z));
			}
		}
	}


} );